import React, { useEffect, useState } from 'react';
import {
  MotifButton,
  MotifDatePicker,
  MotifFormField,
  MotifIcon,
  MotifLabel,
  MotifModal,
  MotifModalBody,
  MotifModalHeader,
  MotifModalFooter,
  MotifTimeInput,
  MotifTooltip,
} from '@ey-xd/motif-react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { getFormattedDate, getFormattedDateAndTime } from '../../../util/commonUtil';
import { actionIcDateRange24px } from '@ey-xd/motif-react/assets/icons';
import { System_Date_Time_State } from '../../../recoil/recoil';
import { useRecoilState } from 'recoil';
import { BUTTON_TITLE } from '../../../constants/commonConstants';

function DateTimePicker() {
  const navigate = useNavigate();
  const [DateValue, setDateValue] = useState(new Date());
  const [timeValue, setTimeValue] = useState(new Date());
  const [showDateTimePickerModal, setShowDateTimePickerModal] = useState(false);
  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);

  useEffect(() => {
    if (!!localStorage.getItem('modifiedSystemDateAndTime')) {
      setDateValue(
        new Date(getFormattedDateAndTime(localStorage.getItem('modifiedSystemDateAndTime'))),
      );
      setTimeValue(
        new Date(getFormattedDateAndTime(localStorage.getItem('modifiedSystemDateAndTime'))),
      );
    }
  }, [localStorage.getItem('modifiedSystemDateAndTime')]);

  const DateTimeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 350px;
  `;

  const HeaderWrapper = styled.span`
    display: flex;
    align-item: start;
    justify-content: center;
  `;

  const HeaderTitle = styled.span`
    font-size: 16px;
    margin-left: 10px;
  `;

  const onResetClick = () => {
    navigate('/');
    if (!!localStorage.getItem('modifiedSystemDateAndTime')) {
      localStorage.removeItem('modifiedSystemDateAndTime');
    }
    window.location.reload();
  };

  const onSubmitClick = () => {
    let modifiedSystemDateAndTime =
      getFormattedDate(DateValue) + 'T' + timeValue.toUTCString().split(' ')[4] + 'Z';
    localStorage.setItem('modifiedSystemDateAndTime', modifiedSystemDateAndTime);
    setSystemDateTime(modifiedSystemDateAndTime);
    setShowDateTimePickerModal(false);
    window.location.reload();
  };

  const closeDateTimePickerModal = () => {
    setShowDateTimePickerModal(false);
  };

  return (
    <>
      {' '}
      {(process.env.REACT_APP_DATEPICKER_FEATURE_FLAG == 'DEV' ||
        process.env.REACT_APP_DATEPICKER_FEATURE_FLAG == 'UAT' ||
        process.env.REACT_APP_DATEPICKER_FEATURE_FLAG == 'SPSQA') && (
        <MotifTooltip
          id="bottom"
          trigger={
            <MotifIcon
              src={actionIcDateRange24px}
              style={{ color: '#000000', cursor: 'pointer', marginLeft: '10px' }}
              onClick={() => setShowDateTimePickerModal(true)}
            />
          }
          allowHover={true}
          allowClick={true}
          placement="bottom"
        >
          Click here to modify system date and Time.
        </MotifTooltip>
      )}
      <MotifModal variant="alt" show={showDateTimePickerModal} onClose={closeDateTimePickerModal}>
        <MotifModalHeader>
          <HeaderWrapper>
            <MotifIcon style={{ color: '#ffffff', lineHeight: 1 }} src={actionIcDateRange24px} />
            <HeaderTitle>Select Date and Time</HeaderTitle>
          </HeaderWrapper>
        </MotifModalHeader>
        <MotifModalBody>
          <DateTimeContainer>
            {/* Date Picker */}
            <MotifFormField>
              <MotifLabel>Pick a Date</MotifLabel>
              <MotifDatePicker
                value={DateValue}
                onChange={date => {
                  setDateValue(date);
                }}
                showLeadingZeros={true}
                format="dd-MM-yyyy"
                yearPlaceholder="YYYY"
                dayPlaceholder="DD"
                monthPlaceholder="MM"
              />
            </MotifFormField>

            {/* Time Picker */}
            <MotifFormField>
              <MotifTimeInput
                value={timeValue}
                onChange={newValue => {
                  setTimeValue(newValue);
                }}
              />
            </MotifFormField>

            <div style={{ width: '350px' }}>
              <h3>Notes:</h3>
              <ol>
                <li>Press 'Submit' button to apply visible date and time.</li>
                <li>Press 'Reset' button to use server date and time from API.</li>
                <li>
                  If you have submited manual date earlier then Reset option is must to use server
                  date and time.
                </li>
              </ol>
            </div>
          </DateTimeContainer>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            size="large"
            variant="secondary"
            style={{ backgroundColor: '#ffe600' }}
            onClick={onSubmitClick}
          >
            {BUTTON_TITLE.SUBMIT}
          </MotifButton>

          <MotifButton size="large" variant="secondary" type="button" onClick={onResetClick}>
            {BUTTON_TITLE.RESET}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
}

export default DateTimePicker;
